import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useState } from 'react';

const MainLayout = ({ children }: any) => {
	const { pathname } = useLocation();

	const [isOpenSidebar, setIsOpenSidebar] = useState<boolean>(false);

	if (pathname === '/login') return children;

	return (
		<div className='flex flex-col w-full h-full bg-gray-100'>
			<Header
				isOpenSidebar={isOpenSidebar}
				setIsOpenSidebar={setIsOpenSidebar}
			/>
			<div className='flex flex-grow relative min-h-screen'>
				<div className={`${isOpenSidebar ? 'block fixed h-full' : 'hidden'} lg:block fixed h-[100%] top-[88px] z-20`}>
					<Sidebar 
						closeSidebar={() => setIsOpenSidebar(false)}
					/>
				</div>
				<div className='px-5 py-5 flex-grow overflow-x-scroll lg:ml-[230px] lg:mt-[90px] mt-[100px]'>{children}</div>
			</div>
		</div>
	);
};

export default MainLayout;
